import type React from 'react';
import SvgMaskIcon from '../SvgMaskIcon';

interface ArrowLeftIconProps {
    width?: number;
    height?: number;
    color?: string;
}

const INNER =
    '<g fill="none" stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
    '<path d="M19 12H5"/><path d="m12 19-7-7 7-7"/></g>';

const ArrowLeftIcon: React.FC<ArrowLeftIconProps> = ({
    width = 20,
    height = 20,
    color = '#656565',
}) => <SvgMaskIcon viewBox="0 0 24 24" inner={INNER} width={width} height={height} color={color} />;

export default ArrowLeftIcon;
